export enum OrderTabs {
  ActionRequired = 'ACTION_REQUIRED',
  Active = 'ACTIVE',
  Ahead = 'AHEAD',
  All = 'ALL',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  InDelivery = 'IN_DELIVERY',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Processing = 'PROCESSING',
  Ready = 'READY',
}
